export default __webpack_public_path__ + "static/media/no_cancel_req.1a04d9c7.svg";